<template>
  <div>
      <Form style="margin: 40px auto 0;">
        <div class="toLogin">
          <h3>密码重置成功，将在<span>{{time}}</span>秒后返回登录页面.</h3>
        </div>
      </Form>
  </div>
</template>

<script>
  export default {
    name: "Step4",
    props:['userList'],
    components: {
    },
    data () {
      return {
        loading: false,
        time: 0,
        cd:null
      }
    },
    methods: {
      countDown(){
        let that = this;
        that.time--;
        if(that.time == 0){
           clearInterval(this.cd)
           var event = new CustomEvent('changeType', {"detail": {type: '密码登录'}});
          document.dispatchEvent(event);
        }
      }
    },
    mounted(){
      let that = this;
      that.time = 2;
      this.$Message.info("重置成功！");
      this.cd = setInterval(that.countDown, 1000);
    },
    watch: {
      time: function (newVal,oldVal) {
        if (newVal == 0) {
          var params = {
            username: this.userList.username
          };
          // this.$router.push({name: 'login', params}
        }
      }
    }
  }
</script>
<style scoped>
  .toLogin{
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/common/Step4.vue